"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const genius_1 = __importDefault(require("../types/genius"));
const create2DAccessor_1 = __importDefault(require("../utils/create2DAccessor"));
const masterData_json_1 = require("../masterData.json");
/** The table of genius factors. */
exports.default = create2DAccessor_1.default({ label: genius_1.default, table: masterData_json_1.genius });
//# sourceMappingURL=geniusTable.js.map